import { pluginListResponseSchema, pluginUsersResponseSchema, pluginInventoryRequestSchema, pluginInventoryResponseSchema, pluginInventoryDeleteRequestSchema, pluginInventoryDeleteResponseSchema, listPersonalPluginsParamsSchema, listOrgPluginsParamsSchema, pluginFilterOptionsQuerySchema, personalPluginFilterOptionsQuerySchema, pluginFilterOptionsResponseSchema, pluginIdSchema, } from '../contracts/plugins';
import { serializeTableQueryParams } from '../contracts/table';
import { parseSchema } from '../errors';
import { organizationIdSchema, } from '../contracts/organizations';
/**
 * List org plugins on the canonical DataTable contract. Filters are the
 * canonical `FilterValue[]` and are serialized as `field[operator]=v1,v2` via
 * `serializeTableQueryParams`.
 */
export async function listOrganizationPlugins(client, organizationId, params = {}) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedParams = parseSchema(listOrgPluginsParamsSchema, params);
    const queryString = serializeTableQueryParams(validatedParams);
    const data = await client.get(`/organizations/${validatedId}/plugins${queryString ? `?${queryString}` : ''}`);
    return parseSchema(pluginListResponseSchema, data);
}
/**
 * Fetch dynamic filter options for one org Plugins column (Name / Marketplace /
 * Users), with server-side search and offset pagination. Mirrors
 * `getMCPFilterOptions`.
 */
export async function getPluginFilterOptions(client, organizationId, params) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedParams = parseSchema(pluginFilterOptionsQuerySchema, params);
    const response = await client.get(`/organizations/${validatedId}/plugins/filter-options`, { params: validatedParams });
    return parseSchema(pluginFilterOptionsResponseSchema, response);
}
/**
 * List the requesting user's own plugins on the canonical DataTable contract.
 * Same `field[operator]=v1,v2` serialization as the org list — no org id, and
 * no `users` filter (account scope is single-user).
 */
export async function listUserPlugins(client, params = {}) {
    const validatedParams = parseSchema(listPersonalPluginsParamsSchema, params);
    const queryString = serializeTableQueryParams(validatedParams);
    const data = await client.get(`/account/plugins${queryString ? `?${queryString}` : ''}`);
    return parseSchema(pluginListResponseSchema, data);
}
/**
 * Fetch dynamic filter options for one personal Plugins column (Name /
 * Marketplace). Mirrors `getPluginFilterOptions` without the org id.
 */
export async function getUserPluginFilterOptions(client, params) {
    const validatedParams = parseSchema(personalPluginFilterOptionsQuerySchema, params);
    const response = await client.get('/account/plugins/filter-options', {
        params: validatedParams,
    });
    return parseSchema(pluginFilterOptionsResponseSchema, response);
}
export async function getPluginUsers(client, organizationId, pluginName, marketplace) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    // pluginName lives in the URL path; marketplace is a query param (nullable,
    // empty = the NULL-marketplace bucket).
    const query = marketplace !== null
        ? `?marketplace=${encodeURIComponent(marketplace)}`
        : '';
    const response = await client.get(`/organizations/${validatedId}/plugins/${encodeURIComponent(pluginName)}/users${query}`);
    return parseSchema(pluginUsersResponseSchema, response);
}
export async function upsertUserPluginInventory(client, data) {
    const validatedData = parseSchema(pluginInventoryRequestSchema, data);
    const response = await client.post('/account/plugins', validatedData);
    return parseSchema(pluginInventoryResponseSchema, response);
}
export async function removeUserPluginInventory(client, pluginId, data) {
    const validatedPluginId = parseSchema(pluginIdSchema, pluginId);
    const validatedData = parseSchema(pluginInventoryDeleteRequestSchema, data);
    const response = await client.delete(`/account/plugins/${encodeURIComponent(validatedPluginId)}`, { data: validatedData });
    return parseSchema(pluginInventoryDeleteResponseSchema, response);
}
//# sourceMappingURL=plugins.js.map